<template>
    <div class="user-module w-full">
        <div class="flex mt-8 w-full">
            <div class="flex w-4/5">
                <div class="flex flex-col px-6 w-1/3">
                    <div class="form-group">
                        <label for="name">Naziv kupca</label>
                        <input
                            tabindex="1"
                            id="name"
                            class="form-control"
                            :class="{ _error: validationErrors.name}"
                            type="text"
                            v-model="form.name"
                        >
                        <span class="error-message" v-if="validationErrors.name" v-text="validationErrors.name[0]"></span>
                    </div>
                </div>

                <div class="flex flex-col px-6 w-1/3">
                    <div class="form-group flex items-center mt-3">
                        <div class="box-switch">
                            <input
                                tabindex="2"
                                type="checkbox"
                                id="status"
                                name="status"
                                v-model="form.status"
                            >
                            <span class="switch-path"></span>
                            <label for="status" v-text="form.status ? 'Aktivan' : 'Neaktivan'"></label>
                        </div>
                        <span class="error-message" v-if="validationErrors.status" v-text="validationErrors.status[0]"></span>
                    </div>
                </div>
            </div>
            <div class="flex justify-start items-end w-1/5">
                <div class="flex flex-col">
                    <button
                        class="btn primary"
                        @click="submitForm()"
                        :disabled="procesing"
                    >Spremi</button>
                </div>
            </div>
        </div>
        <div>
            <h2 class="w-full mr-4" v-if="redirectMessage" v-text="redirectMessage"></h2>
        </div>
        <response
            v-if="showResponse"
            :data="responseData"
        ></response>
    </div>
</template>
<script>
import Response from './Response'

export default {
    components: {
        Response,
    },

    props: {
        customerData: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            form: {
                name: '',
                status: true,
            },
            validationErrors: {},
            redirectMessage: '',
            showResponse: false,
            responseData: {},
            procesing: false,
        }
    },

    created() {
        this.showLoader();
        // Set the inputs to values to given user data
        if (this.customerData.id) {
            _.forEach(this.form, (item, key) => {
                switch (key) {
                    case 'status':
                        this.form[key] = this.customerData.deleted_at == null
                        break;
                    default:
                        this.form[key] = this.customerData[key]
                        break;
                }
            })
        }
        setTimeout(() => {
            this.hideLoader();
        }, 500);
    },

    methods: {
        // Submit the form to create a new customer
        submitForm() {
            this.procesing = true

            this.showLoader();

            const lastPage = localStorage.getItem('customers_last_page');

            let formData = new FormData();
            let endpoint = '';

            // Append all form items
            _.forEach(this.form, (item, key) => {
                switch (key) {
                    default:
                        formData.append(key, item)
                        break;
                }
            })

            // Conditionaly add method to form submit
            if (this.customerData.id) {
                formData.append("_method", 'PATCH');
            }


            if (lastPage) {
                formData.append('page', lastPage);
            }

            // Sets the endpoint with data for store/update depending on create or update
            if (this.customerData.id) {
                let data = {
                    customer: this.customerData.id,
                }
                console.log(data);
                endpoint = route('customers.update', data)
            } else {
                endpoint = route('customers.store')
            }

            // Send the formData to customer controller store/update function depending on endpoint
            axios.post(endpoint, formData)
                .then((response) => {
                    if (response.status === 200) {
                        this.responseData = response.data.data
                        this.showResponse = true

                        setTimeout(() => {
                            this.hideLoader();

                            const lastPage = localStorage.getItem('customers_last_page');
                            localStorage.removeItem('vue-tables.customers.page');

                            let redirectUrl = route('customers.index');
                            if (lastPage) {
                                redirectUrl += `?page=${lastPage}`;
                            }

                            window.location.href = redirectUrl;
                        }, 2000);

                    }
                })
                .catch((error) => {
                    this.procesing = false
                    if (typeof(error.response) !== 'undefined')
                        this.validationErrors = error.response.data.errors

                    console.error(error);
                    this.hideLoader();
                });
        },
    }
}
</script>
